var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 236 603",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.920611,
    y: 0.920611,
    width: 233.835,
    height: 601.159,
    fill: "#2D2F3A",
    stroke: "#484C59",
    strokeWidth: 1.84122
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84082 445.576L49.7126 497.59V497.59L1.84082 549.605V445.576Z",
    fill: "#343744"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.835 445.576L185.963 497.59V497.59L233.835 549.605V445.576Z",
    fill: "#343744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.998 493.447H175.836",
    stroke: "#343744",
    strokeWidth: 0.920611
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1064 493.447H181.728",
    stroke: "#343744",
    strokeWidth: 1.01267
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.624 482.4H188.209",
    stroke: "#343744",
    strokeWidth: 1.11395
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4951 473.194H195.339",
    stroke: "#343744",
    strokeWidth: 1.22534
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6533 463.988H203.181",
    stroke: "#343744",
    strokeWidth: 1.34787
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0264 454.782H211.807",
    stroke: "#343744",
    strokeWidth: 1.48266
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5381 445.576H221.297",
    stroke: "#343744",
    strokeWidth: 1.63093
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93.9023,
    y: 134.409,
    width: 46.9511,
    height: 234.756,
    rx: 23.4756,
    fill: "#343744"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20605,
    y: 139.933,
    width: 36.8244,
    height: 8.49794,
    fill: "#343744"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 226.47,
    y: 350.965,
    width: 36.8244,
    height: 8.49794,
    transform: "rotate(180 226.47 350.965)",
    fill: "#343744"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20605,
    y: 148.431,
    width: 8.49794,
    height: 55.2366,
    fill: "#343744"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 226.47,
    y: 342.467,
    width: 8.49794,
    height: 55.2366,
    transform: "rotate(180 226.47 342.467)",
    fill: "#343744"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20605,
    y: 44.1893,
    width: 36.8244,
    height: 8.49794,
    fill: "#343744"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 46.2422,
    y: 44.1893,
    width: 36.8244,
    height: 8.49794,
    transform: "rotate(90 46.2422 44.1893)",
    fill: "#343744"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20605,
    y: 50.6335,
    width: 8.2855,
    height: 79.1725,
    fill: "#343744"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 36.8244,
    height: 8.49794,
    transform: "matrix(-1 0 0 1 226.683 44.1893)",
    fill: "#343744"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 36.8244,
    height: 8.49794,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 189.646 44.1893)",
    fill: "#343744"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 8.2855,
    height: 79.1725,
    transform: "matrix(-1 0 0 1 226.683 50.6335)",
    fill: "#343744"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20605,
    y: 213.582,
    width: 36.8244,
    height: 8.49794,
    fill: "#343744"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20605,
    y: 222.08,
    width: 8.49794,
    height: 55.2366,
    fill: "#343744"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 226.471,
    y: 277.316,
    width: 36.8244,
    height: 8.49794,
    transform: "rotate(180 226.471 277.316)",
    fill: "#343744"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 226.471,
    y: 268.818,
    width: 8.49794,
    height: 55.2366,
    transform: "rotate(180 226.471 268.818)",
    fill: "#343744"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20605,
    y: 287.23,
    width: 36.8244,
    height: 8.49794,
    fill: "#343744"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 9.20605,
    y: 295.728,
    width: 8.49794,
    height: 55.2366,
    fill: "#343744"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 226.471,
    y: 203.667,
    width: 36.8244,
    height: 8.49794,
    transform: "rotate(180 226.471 203.667)",
    fill: "#343744"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 226.471,
    y: 195.169,
    width: 8.49794,
    height: 55.2366,
    transform: "rotate(180 226.471 195.169)",
    fill: "#343744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapVertical);
export default __webpack_public_path__ + "static/media/Map_vertical.2a5584986d9e44ad4134e91ec35a9a45.svg";
export { ForwardRef as ReactComponent };